/* ---------------------------------------------------------------------------
   Shop Perks - detail popups.
   Scrolling, dragging and the arrows now come from the shared assets/hp-rail.js.
   Native <dialog> gives the focus trap and Escape handling; the open attribute
   is observed because the close event is not reliable across browsers.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  function init(scope) {
    var roots = (scope || document).querySelectorAll('.hp-perks');
    [].slice.call(roots).forEach(function (root) {
      if (root.hpPerksDialogs) return;
      root.hpPerksDialogs = true;

      root.addEventListener('click', function (e) {
        var opener = e.target.closest ? e.target.closest('[data-perk-dialog]') : null;
        if (opener) {
          var d = document.getElementById(opener.getAttribute('data-perk-dialog'));
          if (!d) return;
          d.perkOpener = opener;
          if (d.showModal) d.showModal();
          else d.setAttribute('open', '');
          return;
        }
        var closer = e.target.closest ? e.target.closest('[data-perk-dialog-close]') : null;
        if (closer) {
          var dc = closer.closest('dialog');
          if (dc) { if (dc.close) dc.close(); else dc.removeAttribute('open'); }
        }
      });

      [].slice.call(root.querySelectorAll('.hp-perks__dialog')).forEach(function (d) {
        d.addEventListener('click', function (e) {
          if (e.target === d && d.close) d.close();
        });
        if (window.MutationObserver) {
          new MutationObserver(function () {
            if (d.hasAttribute('open')) return;
            if (d.perkOpener && d.perkOpener.focus) d.perkOpener.focus();
          }).observe(d, { attributes: true, attributeFilter: ['open'] });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
